import React from 'react';

class PQLogo extends React.Component {
 
	render() {
		const width = this.props.size.width;
		const height = this.props.size.height;

		return (
			<img className={this.props.class} src={process.env.PUBLIC_URL + "images/plinqit_whitelogo.png"} style={{width : width, height: height}} alt="Plinqit Logo" />
			);
	}
}

class PQDLogo extends React.Component {

	render() {
		const width = this.props.size.width;
		const height = this.props.size.height;

		return (
			<img className={this.props.class} src={process.env.PUBLIC_URL + "images/plinqit-dashboard.png"} style={{width : width, height : height}} alt="Plinqit Dashboard Logo" />
		);
	}
}

class FILogo extends React.Component {
	render() {
		const width = this.props.size.width;
		const height = this.props.size.height;

		window._fiSponsor.loadSessionInfo();

		return (
			<img className={this.props.class} src={window._fiSponsor.sponsors[0].logo_white_url} style={{width : width, height : height}} alt="FI Logo" />
		);
	}
}

export {PQLogo, PQDLogo, FILogo};